import { render } from "./UploadDocumentos.vue?vue&type=template&id=5dde3364&scoped=true"
import script from "./UploadDocumentos.vue?vue&type=script&lang=js"
export * from "./UploadDocumentos.vue?vue&type=script&lang=js"

import "./UploadDocumentos.vue?vue&type=style&index=0&id=5dde3364&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dde3364"]])

export default __exports__